import { FieldWrapper } from '@dixa/lib-shared-habla';
import { Component } from 'react';

import Spinner from '../../ajax/components/Spinner';
import ColorPicker from '../colorPicker/ColorPicker';

import styles from './ColorField.module.scss';

type PropsT = {
  className?: string;
  hidden?: string | null;
  input: any;
  label: string;
  meta?: any;
  onChangeAction?: ((e: any) => void) | null;
  showSpinner?: boolean;
};

export default class ColorField extends Component<PropsT> {
  constructor(props: PropsT) {
    super(props);
  }

  render() {
    const { label, input, meta, showSpinner, className, onChangeAction } =
      this.props;

    let spinner: JSX.Element | null = null;

    if (showSpinner === true) {
      spinner = <Spinner className="dark input" />;
    }

    return (
      <FieldWrapper className={className} label={label} meta={meta}>
        <div className={styles.input}>
          <ColorPicker
            color={input.value}
            onChange={(e: any) => {
              if (typeof onChangeAction === 'function') {
                onChangeAction(e);
              }
              input.onChange(e);
            }}
          />
          {spinner}
        </div>
      </FieldWrapper>
    );
  }
}
